import gql from 'graphql-tag';

const VENDOR_BATCH_LIST = gql`
  query Query {
    deviceBatchList {
      batch
    }
  }
`;

export default VENDOR_BATCH_LIST;
